import {Injectable} from '@angular/core';
import {LazyCatalog} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CatalogService} from '../../../../../../compob2b-admin/src/app/cabinet/pim/catalog/catalog.service'

@Injectable({
  providedIn: 'root'
})
export class CustomerCatalogService extends CatalogService {

  get apiUrl() {
    return '/catalog';
  }

  initCatalogTree(): Observable<LazyCatalog[]> {
    return this.compoApiService.get<LazyCatalog[]>(`${this.apiUrl}/tree`)
      .pipe(
        map(response => response.data)
      );
  }

  getLazyChildren(id: number): Observable<LazyCatalog[]> {
    return this.compoApiService.get<LazyCatalog[]>(`${this.apiUrl}/tree/${id}`)
      .pipe(map(response => response.data));
  }
}
